<template>
  <div style="background-color: white">
    <el-row style="padding-top: 10px">
      <el-col :span="24">
        <el-button
          size="small"
          class="btn"
          type="primary"
          v-if="show.lr"
          @click="handleCreate"
          >录入</el-button
        >
        <!-- <el-button size="small" type="primary" disabled="true" class="btn">导出列表</el-button> -->
        <el-form
          :inline="true"
          ref="deviceInfo"
          :model="deviceInfo"
          class="demo-form-inline"
          style="float: right !important"
        >
          <el-form-item label="筛选单位">
            <el-cascader
            v-model="deviceInfo.selectCompanyCode"
              :options="companyTree"
              :show-all-levels="false"
              :props="props"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="lable.checkTime">
            <el-date-picker
              v-model="deviceInfo.date"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="deviceInfo.jjts"
              clearable
              :placeholder="lable.juts"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="deviceInfo.content"
              auto-complete="off"
              placeholder="请输入搜索内容"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="getDeviceinfo"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }"
          ref="multipleTable"
          :data="deviceData"
          tooltip-effect="dark"
          style="width: 100%; text-align: center"
          stripe
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            :label="lable.index"
            type="index"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="glbh"
            sortable
            :label="lable.glbh"
            show-overflow-tooltip
          >
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link
                :underline="false"
                @click="luru(scope.row)"
                style="color: #4095e5; text-decoration: none"
              >
                {{ scope.row.glbh }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="zcbh"
            sortable
            :label="lable.zcbh"
            width="120PX"
          >
          </el-table-column>
          <el-table-column
            prop="zcmc"
            sortable
            :label="lable.jdsb"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="companyName"
            sortable
            :label="lable.companyName"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="sccj"
            :label="lable.sccj"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="jdzq"
            :label="lable.jdzq"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="jdrq"
            :label="lable.checkTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="xcjdrq"
            sortable
            :label="lable.nextCheckTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="juts" :label="lable.juts"> </el-table-column>
          <el-table-column sortable :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                v-if="(scope.row.juts >= 0) & (scope.row.juts <= 30)"
                style="color: #4095e5"
                >即将到检</span
              >
              <span v-else-if="scope.row.juts < 0" style="color: gray"
                >已过检</span
              >
              <span v-else style="color: blueviolet">正常</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination
          v-if="deviceData.length > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  selectAllWarning,
  findByModule,
  findByUserIdCompanyTree,
} from "../../api/api";
export default {
  name: "Warning",
  data() {
    return {
      companyTree: [],
      deviceInfo: {
        date: "",
        content: "",
        state: "",
        jjts: 30,
      },
      show: {
        lr: false,
      },
      lable: {},
      props: {
        checkStrictly: true,
        emitPath: false,

        label: "companyName",
        value: "companyCode",
        children: "zcompany",
      },
      options: [
        {
          label: "30天内预检设备",
          value: 30,
        },
        {
          label: "90天内预检设备",
          value: 90,
        },
        {
          label: "180天内预检设备",
          value: 180,
        },
        {
          label: "全部设备",
          value: "",
        },
        {
          label: "正常设备",
          value: 999,
        },
      ],
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      multipleSelection: [],
      deviceData: [],
    };
  },
  methods: {
    handleCreate() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.warning("只能选择一条信息"); // .....失败信息
      } else if (currentSelect.length == 1) {
        let val = {
          path: "/AddVenfication",
          name: "录入检定",
        }; // debugger //保存数据
        sessionStorage.setItem("addVer", true);
        this.$set(currentSelect[0], "show", true);
        var checkedIdStr = JSON.stringify(currentSelect[0]);
        sessionStorage.setItem("data", checkedIdStr); //添加路由跳转至查看设备
        this.$router.push({
          path: "AddVenfication",
        });
        this.$store.commit("pushtags", val);
      } else {
        this.$message.warning("请选择设备");

        // let val = {
        //   path: "/AddVenfication",
        //   name: "录入检定"
        // }; // debugger //保存数据
        // // var checkedIdStr = JSON.stringify(currentSelect[0]);
        // // sessionStorage.setItem("data", checkedIdStr); //添加路由跳转至查看设备
        // this.$router.push({
        //   path: "AddVenfication"
        // });
        // this.$store.commit("pushtags", val);
      }
    },

    luru(row) {
      if (this.show.lr) {
        let val = {
          path: "/AddVenfication",
          name: "录入检定",
        }; // debugger //保存数据
        this.$set(row, "show", true);
        var checkedIdStr = JSON.stringify(row);
        sessionStorage.setItem("addVer", true);
        sessionStorage.setItem("data", checkedIdStr); //添加路由跳转至查看设备
        this.$router.push({
          path: "AddVenfication",
        });
        this.$store.commit("pushtags", val);
      } else {
        this.$message.warning("你不具有录入权限");
      }
    },
    //查找设备信息
    getDeviceinfo() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      if (sessionStorage.getItem("addVer") == "true") {
        if (sessionStorage.getItem("VerWarningIndex") != undefined) {
          this.pageIndex = sessionStorage.getItem("pageIndex") * 1;
          if (sessionStorage.getItem("addVer") == "true") {
            sessionStorage.setItem("VerWarningIndex", false);
          }
        }
      }

      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: this.deviceInfo.state,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        companyCode:this.deviceInfo.selectCompanyCode,
        jdlx: 0,
        jjts: this.deviceInfo.jjts,
        userId: userinfo.userId,
      };
      selectAllWarning(map).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.deviceData = data.list;
          this.total = data.total;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      sessionStorage.setItem("VerWarningIndex", val);
      this.getDeviceinfo();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getDeviceinfo();
    },
    findLable() {
      findByModule("设备检定").then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var  companyCode='';
      if (userinfo.userRole == 1 || (userinfo.fjqx != null && (userinfo.fjqx.indexOf ("3")!=-1||userinfo.fjqx.indexOf ("4")!=-1))) {
        companyCode="-1"
      }else{
        companyCode=userinfo.companyCode
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companyTree = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
  },
  created() {
    this.findLable();
    this.getDeviceinfo();
    this.getCompanyTree();
    var userinfo = JSON.parse(localStorage.getItem("user"));
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "87") {
        this.show.lr = true;
      }
    });
  },
  // keep-alive 缓存后重新激活时，保留搜索条件刷新列表
  activated() {
    this.getDeviceinfo();
  },
};
</script>
<style >
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/verification/Warning.vue